import React from 'react'
import {VendorPersonalDetail} from './cards/VendorPersonalDetail'
import { useLocation } from 'react-router-dom';
export function Settings() {

  const location = useLocation()
  //the data here will be an object since an object was
  const vendorId:any = location.state;

  
  return (
    <>
      <VendorPersonalDetail />
      
    </>
  )
}
